/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_cart_errors_price = /** @type {(inputs: {}) => string} */ () => {
	return `Cena byla aktualizována`
};

const da_cart_errors_price = /** @type {(inputs: {}) => string} */ () => {
	return `Prisen er blevet opdateret`
};

const de_cart_errors_price = /** @type {(inputs: {}) => string} */ () => {
	return `Der Preis wurde aktualisiert`
};

const en_cart_errors_price = /** @type {(inputs: {}) => string} */ () => {
	return `The price has been updated`
};

const es_cart_errors_price = /** @type {(inputs: {}) => string} */ () => {
	return `El precio ha sido actualizado`
};

const fr_cart_errors_price = /** @type {(inputs: {}) => string} */ () => {
	return `Le prix a été mis à jour`
};

const hu_cart_errors_price = /** @type {(inputs: {}) => string} */ () => {
	return `Az ár frissítésre kerül`
};

const it_cart_errors_price = /** @type {(inputs: {}) => string} */ () => {
	return `Il prezzo è stato aggiornato`
};

const nl_cart_errors_price = /** @type {(inputs: {}) => string} */ () => {
	return `De prijs is bijgewerkt`
};

const pl_cart_errors_price = /** @type {(inputs: {}) => string} */ () => {
	return `Cena została zaktualizowana`
};

const pt_cart_errors_price = /** @type {(inputs: {}) => string} */ () => {
	return `O preço foi atualizado`
};

const sv_cart_errors_price = /** @type {(inputs: {}) => string} */ () => {
	return `Priset har uppdaterats`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const cart_errors_price = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cart_errors_price(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("cart_errors_price", locale)
	if (locale === "cs") return cs_cart_errors_price(inputs)
	if (locale === "da") return da_cart_errors_price(inputs)
	if (locale === "de") return de_cart_errors_price(inputs)
	if (locale === "en") return en_cart_errors_price(inputs)
	if (locale === "es") return es_cart_errors_price(inputs)
	if (locale === "fr") return fr_cart_errors_price(inputs)
	if (locale === "hu") return hu_cart_errors_price(inputs)
	if (locale === "it") return it_cart_errors_price(inputs)
	if (locale === "nl") return nl_cart_errors_price(inputs)
	if (locale === "pl") return pl_cart_errors_price(inputs)
	if (locale === "pt") return pt_cart_errors_price(inputs)
	return sv_cart_errors_price(inputs)
};
export { cart_errors_price as "cart_errors.price" }